export default __webpack_public_path__ + "static/media/dickblick.08643525.svg";